<template>
	<div>
		<div v-html="headHtml"></div>
	</div>
</template>

<script>
	import publicMethod from '@/views/publicMethod'
	export default {
		mixins: [publicMethod],
		data() {
			return{
				headHtml:window.headerTemplate
				
			}
		},
		mounted() {
			this.loadResources_(window.resources)
			// console.log('头部代码---',window.headerTemplate)
			
		},
		methods:{
			
			
		}
		
	}
	
</script>

<style>
</style>